module.exports = __webpack_public_path__ + "static/media/create_list_ja.75dbd6de.gif";